import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import type { PaymentBankLinks } from '../../model/payment-bank-links.js';
import { bankMatchQueries } from './bank-match-queries.js';

export const usePaymentBankLinksQuery = (paymentId: string): UseQueryResult<PaymentBankLinks> =>
  useQuery(bankMatchQueries.paymentLinks(paymentId));
